
import {BaseResource} from "./Resource";

/**
 * Approval Resource
 */
class Approval extends BaseResource
{
    constructor() {
        super();
        this.handle = 'approval'
        this.resourceSegments = ['approvals']
    }

    all(params = {}) {
        return this._doGet([], params)
    }

    store(data = {}) {
        return this._doPost([], data)
    }

    approve(id) {
        return this._doPost([id, 'approve'])
    }

    reject(id, reason) {
        return this._doPost([id, 'reject'], { reason })
    }

    revoke(id) {
        return this._doPost([id, 'revoke'])
    }
}

export let ApprovalResource = new Approval();